import React, { useCallback, useState } from 'react';

import { KALTURA_CONFIGS, KALTURA_API_URL } from 'config/constants';
import { Skeleton } from '@patternfly/react-core';

interface KalturaThumbnailProps extends React.ComponentPropsWithoutRef<'img'> {
  partnerId?: string | number;
  entryId: string | number;
}

const KalturaThumbnail: React.FC<KalturaThumbnailProps> = ({
  partnerId = KALTURA_CONFIGS.partnerId,
  entryId,
  height = 240,
  alt,
  ...props
}) => {
  const [loading, setLoading] = useState(true);

  const onThumbnailLoad = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <>
      <img
        style={{ display: loading ? 'none' : 'block' }}
        alt={alt}
        src={`${KALTURA_API_URL}/p/${partnerId}/thumbnail/entry_id/${entryId}/height/${height}`}
        onLoad={onThumbnailLoad}
        {...props}
      />
      {loading && <Skeleton width="100%" height={`${String(height)}px`} />}
    </>
  );
};

export default KalturaThumbnail;
